export function buildInviteLink(code: string): string {
  const url = new URL('/login', window.location.origin)
  url.searchParams.set('tab', 'register')
  url.searchParams.set('invite_code', code)
  return url.toString()
}
